import { updateKeyInStore } from 'App';
import {
  InvestmentsStateValues,
  TPleaseEnterInformationBelowItem,
  TPleaseProvideDetailsOfAssetsSoldDuringYearItem,
  updateKey,
} from '../slice';

export const uploadFields: IBaseField<
  | keyof InvestmentsStateValues
  | keyof TPleaseProvideDetailsOfAssetsSoldDuringYearItem
  | keyof TPleaseEnterInformationBelowItem
>[] = [
  {
    name: 'uploadForm1099BOrForeignEquivalent',
    label:
      'Upload Form 1099-B, foreign equivalent or summary of transactions report from professional trading program.',
    subLabel: () => (
      <p>
        If summary of transactions report from professional trading program,
        please provide in txt format
      </p>
    ),
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.investments.values.doYouHaveForm1099BAndorBrokerStatementsShowingTheTransction',
  },
  {
    name: 'pleaseUploadForm1099B',
    label: 'Please upload Form 1099-B',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'yes',
    dependentOn:
      'taxQuestionnaire.income.investments.values.didYouCarryOutSalesOfSecuritiesWithAUsFinancialInstitution',
  },
  {
    name: 'ifYouHaveAnExcelSpreadsheetWithTheTransactionsYouCanUploadItInsteadOfCompletingTheTableAbove',
    label:
      'If you have an Excel spreadsheet with the transactions, you can upload it instead of completing the table above',
    type: 'upload',
    predicate: (value) => value === 'no',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.investments.values.didYouCarryOutSalesOfSecuritiesWithAUsFinancialInstitution',
  },
  {
    name: 'pleaseAlsoUploadTheYearEndBrokerageStatementForForeignieNonUsTransactions',
    label:
      'Please also upload the year-end brokerage statement for foreign (ie Non-US) transactions',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.investments.values.didYouCarryOutSalesOfSecuritiesWithAnonUsFinancialInstitiution',
  },
  {
    name: 'uploadAnnualStatementForLast3YearsInWhichTheFundWasHeldshowingYearEndBalance',
    label:
      'Upload annual statement for last 3 years in which the fund was held (showing year-end balance)',
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.income.investments.values.doYouHaveInvestmentsInANonUsPooledInvestmentFundsEGMutualFundsUnitTrustsEtc',
  },
];
